import { TextSearchData } from '../types-store';

export const getTextDataId = (textData: TextSearchData) =>
  `${textData.id}_${textData.textSet ? textData.textSet.v : ''}_${textData.language ? textData.language.v : ''}`;
